// extracted by mini-css-extract-plugin
module.exports = {"section":"widgets-item-FreeQuote_section__WFO_1"};